import React, { Fragment } from 'react';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

// Components

import ImmigrationStatusTooltip from '../tooltips/ImmigrationStatusTooltip';


const Page2_07 = props => {

    const {
        environment: {
            isState
        }
    } = props;
    
    return (
        <Fragment>
            <div id="saPrimaryContact" className="">
                <div className="subsection">
                    <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                        <div className="usa-alert__body gi-alert__info__body">
                            <p className="usa-alert__text gi-alert__info__text">
                                <FormattedMessage id="ssap.family_household.get_ready.notification_one"/>
                                <br/>
                                <FormattedMessage id="ssap.family_household.get_ready.notification_two"/>
                            </p>
                        </div>
                    </div>
                    <p>
                        <FormattedMessage
                            id="ssap.family_household.get_ready.asterisk_reminding"
                            tagName="i"
                        />
                    </p>
                    <p>
                        <FormattedMessage id="ssap.family_household.get_ready.list_header"/>
                    </p>
                    <ul className="usa-list gi-list--ul">
                
                        <FormattedMessage
                            id="ssap.start.get_ready.item.ssn"
                            tagName="li"
                        />
                        <FormattedMessage
                            id="ssap.family_household.get_ready.item.documents"
                            tagName="li"
                            values={{
                                link: (
                                    <ImmigrationStatusTooltip
                                        { ...{
                                            isState
                                        } }
                                    />
                                )
                            }}
                        />
                    </ul>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(Page2_07);
